/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2021 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";
import { otheritemsreceiving } from '../../otheritems/otheritemsreceiving';

export class purchaseindex extends IceEntity {
  purchase_index_key: string = "";
  purchase_order_key: string = "";
  purchase_delivery_key: string = "";
  purchase_order_number: string = "";
  from_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone; // new
  from_trans_account: string = "";
  to_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone; // new
  to_trans_account: string = "";
  bill_status: IceTypes.trans_status = IceTypes.trans_status.isNone; // new 
  created: any = NaN;
  modified: any = NaN;

  constructor() {
    super();
  }

  gettablename(): string {
    return "PURCHASE_INDEX";
  }
}
